import React from 'react';
import { useData } from '../../../contexts';
import { Card, CardContent, CardMedia, Grid } from '@mui/material';
import { VogelvluchtRegisterTable } from './VogelvluchtRegisterMobileTable';
import { MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { InfoPanelMobile } from '../../InfoPanelMobile/InfoPanelMobile';

export const VogelvluchtRegisterMobile = (props: any) => {
  const { data, allIndicators, interactieveToolPath, indicatorPagina } = props;
  const {
    selectedGemeente,
    selectedTopic,
    selectedBenchmarks,
    locale,
    interfaceColor,
    vregColors,
  } = useData();

  const colors = vregColors;

  return (
    <Card className="card-borderless">
      <CardContent>
        <div
          className={'vl-typography'}
          style={{
            paddingLeft: '24px',
            paddingRight: '4px',
            marginBottom: '24px',
            marginRight: '16px',
          }}
        >
          <Tooltip>
            <TooltipTrigger style={{ marginBottom: '2px' }}>
              <h5 className="page-title-mobile">
                Hoe scoort {selectedGemeente.label} op enkele kernindicatoren
                uit registerdatabanken?{' '}
                <MdHelpOutline
                  style={{
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: interfaceColor,
                    top: '2px',
                    position: 'relative',
                    display: 'inline',
                  }}
                />
              </h5>
            </TooltipTrigger>
            <TooltipContent className="TooltipMobile">
              <p>
                In de Gemeente-Stadsmonitor wordt een onderscheid gemaakt tussen
                twee soorten indicatoren.
              </p>
              <br />
              <ul>
                <li>
                  De indicatoren uit geregistreerde databanken of
                  registerindicatoren zijn indicatoren die hoofdzakelijk
                  afkomstig zijn uit databanken van andere (Vlaamse en federale)
                  overheidsinstanties.
                </li>
                <li>
                  De surveyindicatoren zijn afkomstig uit de grootschalige
                  burgerbevraging Gemeente-Stadsmonitor.
                </li>
              </ul>
              <br />
              <p>
                Een overzicht van alle indicatoren die we aanbieden, vind je op
                de pagina 'Overzicht indicatoren'.
              </p>
              <br />
              <p>
                In de interactieve toepassing vind je alle indicatoren terug per
                thema.
              </p>

              <p>
                Via de knop 'Meer informatie' kan je per indicator meteen naar
                de interactieve toepassing gaan.
              </p>
            </TooltipContent>
          </Tooltip>
          <p className={'page-subtitle-mobile'}>
            Ontdek de cijfers van {selectedGemeente.label} ten opzichte van de
            benchmark {selectedBenchmarks[0].label} voor enkele kernindicatoren
            voor het thema {selectedTopic.thema}.
          </p>{' '}
          <div>
            <InfoPanelMobile
              allIndicators={allIndicators}
              data={data}
              interactieveToolPath={interactieveToolPath}
            />
          </div>
          <hr style={{ marginRight: '12px' }} />
        </div>
      </CardContent>
      <CardMedia style={{ width: '100%' }}>
        {data !== undefined && data.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid item xs={12} sx={{ padding: '16px' }}>
              <VogelvluchtRegisterTable data={data} />
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              minHeight={'160px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {' '}
              <p style={{ fontSize: '11px' }}>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </CardMedia>
      <CardMedia>
        <Grid item xs={12}>
          <ul
            style={{
              padding: '0px',
              margin: '0px',
              textAlign: 'center',
              position: 'relative',
              bottom: '20px',
              left: '0px',
            }}
          >
            <li
              style={{
                fontSize: '11px',
                display: 'inline-block',
                marginRight: '20px',
              }}
              key={`item-0`}
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 32 32"
                style={{
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginRight: '4px',
                }}
              >
                <title></title>
                <desc></desc>
                <path
                  fill={colors[0]}
                  cx="16"
                  cy="16"
                  transform="translate(16, 16)"
                  d="M16,0A16,16,0,1,1,-16,0A16,16,0,1,1,16,0"
                ></path>
              </svg>
              <p style={{ float: 'right', position: 'relative', top: '1px' }}>
                {selectedGemeente.label}
              </p>
            </li>
            <li
              style={{
                fontSize: '11px',
                display: 'inline-block',
                marginRight: '20px',
              }}
              key={`item-1`}
            >
              <svg
                width="12"
                height="10"
                viewBox="0 0 32 32"
                style={{
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginRight: '4px',
                }}
              >
                <title></title>
                <desc></desc>
                <path
                  fill={'transparent'}
                  stroke={colors[1]}
                  strokeWidth={5}
                  transform="translate(16, 16)"
                  d="M14,0A14,14,0,1,1,-14,0A14,14,0,1,1,14,0"
                ></path>
              </svg>
              <p style={{ float: 'right', position: 'relative', top: '1px' }}>
                {selectedBenchmarks[0].label}
              </p>
            </li>
            <li
              style={{
                fontSize: '11px',
                display: 'inline-block',
                marginRight: '20px',
              }}
              key={`item-2`}
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 32 32"
                style={{
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  marginRight: '4px',
                }}
              >
                <title></title>
                <desc></desc>
                <line
                  x1="15"
                  x2="15"
                  y1="0"
                  y2="32"
                  stroke={colors[2]}
                  stroke-width="8"
                />
              </svg>
              <p style={{ float: 'right', position: 'relative', top: '1px' }}>
                {'Vlaams Gewest'}
              </p>
            </li>
          </ul>
        </Grid>
      </CardMedia>
    </Card>
  );
};
